module.exports = __webpack_public_path__ + "img/a4.3e3cfc0f.png";